import React from 'react';
import PropTypes from 'prop-types';
// children
import MultiSelect from '../../../../../../../../../shared/components/MultiSelect/MultiSelect';

const AirlineSelect = (props) => {
  const { airlines, dispatch } = props;

  const params = { exportType: 'airlines' };
  const field = {
    fieldType: 'airlines',
    label: 'Airline(s) Optional',
  };

  return (
    <div className='multiselect-wrapper'>
      <MultiSelect
        secondary
        dispatch={dispatch}
        titleLabel={field.label}
        params={params}
        fieldType={field.fieldType}
        airlines={airlines}
      />
    </div>
  );
};

AirlineSelect.propTypes = {
  airlines: PropTypes.array,
  dispatch: PropTypes.func,
};

export default AirlineSelect;



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CompileDataForm/children/AirlineSelections/children/AirlinesSelect.js